import React, { type ComponentProps, useContext } from 'react';

import TeamsAvatar from '@atlaskit/teams-avatar/teams-avatar';

import { TeamInlinePreviewContext } from '../../store/context';

/**
 * Internal component that renders the team avatar using TeamsAvatar.
 * Automatically pulls teamId from context and uses the provided size or defaults to small.
 */
function Avatar(
	props: Omit<ComponentProps<typeof TeamsAvatar>, 'teamId' | 'size' | 'testId'> & {
		size?: ComponentProps<typeof TeamsAvatar>['size'];
	},
): React.JSX.Element {
	const { teamId, getTestId } = useContext(TeamInlinePreviewContext);
	return (
		<TeamsAvatar
			{...props}
			teamId={teamId}
			size={props.size ?? 'small'}
			testId={getTestId('avatar')}
		/>
	);
}

export { Avatar };
